import { styled } from 'styled-components';

export const ScrollableContainer = styled.div`
  height: calc(100vh - 300px); // Adjust this value based on your layout
  overflow-y: auto;
  padding: 16px 24px;
`;

export const CardWrapper = styled.div`
  flex: 0 0 calc(50% - 12px);
  min-width: 560px;

  @media (max-width: 1460px) {
    flex: 0 0 100%;
  }
`;
